import { TooltipProvider } from "@/components/ui/tooltip";
import { NewProjectWizard } from "@/components/new-project/NewProjectWizard";

/**
 * Tynn page-wrapper rundt NewProjectWizard. All wizard-logikk og state lever
 * i komponenten slik at den kan gjenbrukes i ConvertOfferDialog (VIB-686).
 */
export default function NewProjectPage() {
  return (
    <TooltipProvider>
      <div className="px-6 py-8 animate-fade-in max-w-3xl mx-auto">
        <h1 className="page-title">Nytt prosjekt</h1>
        <NewProjectWizard />
      </div>
    </TooltipProvider>
  );
}
